module.exports = __webpack_public_path__ + "static/media/SummerMorning.349f066e.jpg";